
import React from "react";
import { makeStyles } from '@material-ui/styles';

import { IconStyled } from "./IconStyled.js";
import { appConfig } from "../config.js";


const li_title_style = {
    position: "relative",
    zIndex: 1,
    margin: "1%",
}

const useStyles = makeStyles({
    modeSelection: {
        position: "relative",
        zIndex: 1,
        padding: "15px",
        borderBottom: "1px solid rgb(41, 40, 24)",
        transition: "all 200ms ease",
        '&:hover': {
            background: appConfig.theme.backgroundColorLighter1,
            transition: "all 200ms ease",
        },
    },
});


/**
 * Affiche un choix avec icon, titre et description + effet de survol
 * à utiliser dans un <NavLink/> par exemple pour le rendre cliquable
 * 
 * @param {string} iconClass - ex: "fa fa-upload"
 * @param {string} title - "Créez un nouveau wallet"
 * @param {string} description - "cette option vous permet de créer un nouveau wallet"
 * @returns 
 */
const HoverSelector = ({ iconClass, title, description }) => {

    const classes = useStyles();

    return (
        <div className={classes.modeSelection}>
            <h3>
                <p style={li_title_style}>
                    <IconStyled iconClass={iconClass} />
                    {title}
                </p>
            </h3>
            <p style={{ marginLeft: "4%" }}>
                {description}
            </p>
        </div>
    )
}

export default HoverSelector;
